import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const SelectFilterIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M14.79 21.63C13.91 21.71 12.97 21.73 12.04 21.69C11.61 21.65 11.27 21.99 11.26 22.4C11.24 22.81 11.56 23.17 11.97 23.19C12.95 23.24 13.97 23.22 14.93 23.12C15.34 23.08 15.64 22.71 15.61 22.3C15.57 21.89 15.2 21.59 14.79 21.62V21.63Z"
        fill={color}
      />
      <path
        d="M8.41 21.2C7.44 20.97 6.56 20.68 5.86001 20.34C5.49001 20.16 5.04001 20.32 4.86001 20.69C4.68001 21.06 4.84 21.51 5.21 21.69C6.02 22.08 6.98001 22.4 8.06001 22.65C8.12001 22.66 8.17 22.67 8.23 22.67C8.57 22.67 8.88 22.44 8.96 22.09C9.05 21.69 8.8 21.28 8.4 21.19L8.41 21.2Z"
        fill={color}
      />
      <path
        d="M20.43 19.51C19.89 20.05 19.17 20.5 18.28 20.85C17.9 21 17.71 21.44 17.86 21.82C18.01 22.21 18.46 22.39 18.83 22.24C19.91 21.81 20.8 21.25 21.5 20.55C21.8 20.26 21.79 19.79 21.5 19.5C21.21 19.21 20.72 19.22 20.43 19.51Z"
        fill={color}
      />
      <path
        d="M2.77999 15.5C2.68999 15.1 2.28999 14.85 1.87999 14.94C1.47999 15.03 1.21999 15.44 1.31999 15.84C1.56999 16.92 1.87999 17.88 2.25999 18.7C2.43999 19.08 2.88999 19.24 3.25999 19.06C3.63999 18.89 3.79999 18.44 3.61999 18.06C3.28999 17.35 2.99999 16.47 2.77999 15.5Z"
        fill={color}
      />
      <path
        d="M22.78 13.59C22.63 13.2 22.19 13.02 21.81 13.17C21.42 13.32 21.23 13.76 21.39 14.14C21.73 15.03 21.89 15.79 21.84 16.6C21.81 17.01 22.13 17.37 22.54 17.4C22.95 17.43 23.31 17.12 23.34 16.7C23.4 15.67 23.21 14.69 22.79 13.59H22.78Z"
        fill={color}
      />
      <path
        d="M2.29999 11.87C2.25999 10.96 2.27998 10.01 2.36998 9.11999C2.40998 8.70999 2.10999 8.33999 1.69999 8.29999C1.28999 8.25999 0.919985 8.56 0.879985 8.97C0.779985 9.92 0.759985 10.95 0.799985 11.93C0.819985 12.34 1.16999 12.67 1.57999 12.65C1.98999 12.63 2.31999 12.28 2.29999 11.87Z"
        fill={color}
      />
      <path
        d="M19.57 11.04C19.82 11.37 20.29 11.44 20.62 11.19C20.95 10.94 21.02 10.47 20.77 10.14C20.52 9.81 20.25 9.46 19.95 9.11L22.53 6.53C22.67 6.39 22.75 6.2 22.75 6V4C22.75 3.59 22.41 3.25 22 3.25H7C6.59 3.25 6.25 3.59 6.25 4V6C6.25 6.2 6.33 6.39 6.47 6.53L12.25 12.31V19C12.24 19.49 12.76 19.88 13.23 19.71L16.23 18.75C16.54 18.65 16.75 18.36 16.75 18.04V12.31L18.88 10.18C19.12 10.47 19.35 10.76 19.56 11.04H19.57ZM15.47 11.47C15.33 11.61 15.25 11.8 15.25 12V17.49L13.75 17.97V12C13.75 11.8 13.67 11.61 13.53 11.47L7.75 5.69V4.75H21.25V5.69L15.47 11.47Z"
        fill={color}
      />
      <path
        d="M3.5 2.43999C2.79 3.12999 2.23 3.99999 1.79 5.06999C1.63 5.44999 1.82 5.88999 2.2 6.04999C2.57 6.20999 3.02 6.02999 3.18 5.63999C3.53 4.78999 3.97 4.08999 4.55 3.50999C4.85 3.21999 4.85 2.74999 4.56 2.44999C4.27 2.14999 3.8 2.14999 3.5 2.43999Z"
        fill={color}
      />
      <path
        d="M7.44 2.15999C8.2 2.11999 9.02 2.27999 9.9 2.63999C10.28 2.78999 10.72 2.60999 10.88 2.21999C11.03 1.83999 10.85 1.39999 10.46 1.23999C9.37 0.799992 8.33 0.609992 7.36 0.659992C6.95 0.679992 6.63 1.02999 6.65 1.44999C6.67 1.85999 7.01 2.16999 7.44 2.15999Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectFilterIcon.displayName = 'SelectFilterIcon';
